import React, { useCallback } from 'react';
import { get_documents_by_beneficiary_id, delete_document_by_id, download_document_by_id, view_document_by_id } from '../api/document_api';
import GenericDocument from './GenericDocument';

const Documents = ({ beneficiary_id, refreshTrigger }) => {
    const fetchDocs = useCallback(() => {
        return get_documents_by_beneficiary_id(beneficiary_id);
    }, [beneficiary_id]);

    return (
        <GenericDocument 
            title="מסמכי נתמך"
            fetchData={fetchDocs}
            deleteFunc={delete_document_by_id}
            viewFunc={view_document_by_id} 
            downloadFunc={download_document_by_id} 
            refreshTrigger={refreshTrigger}
        />
    );
};

export default Documents;
